import { useChatStore } from "@/entities/chat";
import { Message } from "../model";

export const updateLastMessage = (chatId: string, lastMessage: Message | undefined) => {
    useChatStore.setState((state) => ({
      chats: state.chats.map((chat) =>
        chat._id === chatId ? { ...chat, lastMessage } : chat
      ),
    }));
  };